import React, { useState, useEffect } from "react";
import { getIcons } from "../../Constant/Constant";
import MemberLeadDetailModal from "./MemberLeadDetailModal";
import ImagePopupModal from "./ImagePopupModal";
import ConfirmationModal from "../../shareableContainer/ConfirmationModal";
import CPManageService from "../../Services/CPManageService";

const MemberList = ({ totalMember, mockMembers }) => {
  const [members, setMembers] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMoreMembers, setHasMoreMembers] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  
  const icons = getIcons();

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setMembers(mockMembers);
      setLoading(false);
    }, 800);
  }, [mockMembers]);

  console.log('Loading members', mockMembers);

  useEffect(() => {
    const filteredMembers = searchKey
      ? mockMembers.filter(
          (member) =>
            member.name.toLowerCase().includes(searchKey.toLowerCase()) ||
            member.phoneNumber.toLowerCase().includes(searchKey.toLowerCase())
        )
      : mockMembers;
    setMembers(filteredMembers);
  }, [searchKey, mockMembers]);

  const handlePageChange = (direction) => {
    if (direction === "next") {
      setCurrentPage((prev) => prev + 1);
    } else if (direction === "previous" && currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  const openMemberModal = async (member) => {
    try {
          const memberDetails = await CPManageService.getMemberDetails(member?.uid);
          setSelectedMember(memberDetails.data);
          setShowModal(true);
        } catch (error) {
          console.error(error);
        }
 
  };

  const closeMemberModal = () => {
    setShowModal(false);
    setSelectedMember(null);
  };

  return (
    <div className="mt-10 w-full bg-white rounded-lg shadow-md p-6">
      <div className="flex justify-between flex-col gap-5">
        <h1 className="text-3xl font-semibold 3xl:text-4xl ml-5">
          CP Member &#40;{totalMember}&#41;
        </h1>

        {/* Search */}
        <div className="relative">
          <input
            className="border-customGreen rounded-md border bg-transparent w-[70%] h-10 px-4 pl-10 mx-5 focus:outline-none"
            placeholder="Search by name or department"
            type="search"
            value={searchKey}
            onChange={(e) => setSearchKey(e.target.value)}
          />
          <div className="absolute left-8 top-3 text-gray-400">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </div>
          <button
            className="w-[20%] p-2 text-white h-10 bg-customGreen rounded-md"
          >
            Search
          </button>
        </div>
      </div>

      <div className="overflow-y-auto custom-scrollbar h-[500px] bg-white py-5 px-5">
        {loading ? (
          <div className="flex justify-center items-center h-full">
            <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-customGreen"></div>
          </div>
        ) : members.length === 0 ? (
          <div className="text-center text-gray-500">No members to show.</div>
        ) : (
          members.map((member, index) => (
            <div key={index} className="grid grid-cols-2 gap-4 px-10 py-2 xl:px-5 mt-5 rounded-lg shadow-md cursor-pointer">
          
              <div className="grid w-4/12 text-ellipsis xl:w-full">
                <h1
                  title={member.name}
                  className="text-xl font-bold pt-3 text-ellipsis whitespace-nowrap xl:text-base 4xl:text-2xl truncate hover:text-customGreen"
                  onClick={() => openMemberModal(member)}
                >
                  {member.name}
                </h1>
                <p className="font-medium">{member.phoneNumber}</p>
              </div>
            </div>
          ))
        )}
      </div>

      {/* <div className="flex justify-center my-5 gap-10">
        {currentPage > 1 && (
          <button
            onClick={() => handlePageChange("previous")}
            className="mx-1 px-3 py-1 border rounded text-blue-500"
          >
            <img
              src={icons.previousPagination}
              className="w-3"
              alt="Previous"
            />
          </button>
        )}
        <span>{currentPage}</span>
        {hasMoreMembers && (
          <button
            onClick={() => handlePageChange("next")}
            className="mx-1 px-3 py-1 border rounded text-blue-500"
          >
            <img src={icons.nextPagination} className="w-3" alt="Next" />
          </button>
        )}
      </div> */}

      {showModal && selectedMember && (
        <MemberLeadDetailModal 
        selectedMember={selectedMember} 
        
          onClose={closeMemberModal} 
        />
      )}
    </div>
  );
};

export default MemberList;